import {
  CALENDAR_GRID_WEEK_GRID_LINE_OFFSET,
  CALENDAR_GRID_WEEK_SPAN_END_LINE_OFFSET,
} from '../CalendarGridWeekAllDay.constants'

export function getCalendarGridWeekSpanStyle({ endIndex, startIndex, track }) {
  return {
    '--calendar-grid-span-end':
      endIndex + CALENDAR_GRID_WEEK_SPAN_END_LINE_OFFSET,
    '--calendar-grid-span-start':
      startIndex + CALENDAR_GRID_WEEK_GRID_LINE_OFFSET,
    '--calendar-grid-span-track': track,
  }
}
